import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Cadastro de Concreto',
    path: 'produto',
    name: 'concreto',
    component: () => import('@/views/concreto/concreto/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroProduto],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusão de Concreto',
    path: 'produto/incluir',
    name: 'concretoinsert',
    component: () => import('@/views/concreto/concreto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Inclusão de Concreto',
    path: 'produto/incluir/:id',
    name: 'concretoinsertcopy',
    component: () => import('@/views/concreto/concreto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Edição de Concreto',
    path: 'produto/editar/:id',
    name: 'concretoupdate',
    component: () => import('@/views/concreto/concreto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroProduto]
    }
  },
  {
    description: 'Clima',
    path: 'clima',
    name: 'clima',
    component: () => import('@/views/concreto/clima/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 1,
      ensaioFresco: true,
      permissions: [EPermissoes.CadastrosBase],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusão de Clima',
    path: 'clima/incluir',
    name: 'climainsert',
    component: () => import('@/views/concreto/clima/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'clima',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastrosBase]
    }
  },
  {
    description: 'Edição de Clima',
    path: 'clima/editar/:id',
    name: 'climaupdate',
    component: () => import('@/views/concreto/clima/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'clima',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastrosBase]
    }
  },
  {
    description: 'Fornecedor de Concreto',
    path: 'fornecedor-obra',
    name: 'fornecedorobra-concreto',
    component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Tipo de Ensaio',
    path: 'tipo-ensaio',
    name: 'tipoensaioconcreto',
    component: () => import('@/views/utilidade/tipoensaio/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 1,
      alternarTipoEnsaio: true,
      tipoEnsaioRouteNameFresco: 'tipoensaiofresco',
      tipoEnsaioRouteNameEndurecido: 'tipoensaioendurecido',
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'global'
    }
  },
  {
    description: 'Tipo de Ensaio Fresco',
    path: 'tipo-ensaio-fresco',
    name: 'tipoensaiofresco',
    redirect: { name: 'tipoensaioconcreto' },
    goesToMenu: false,
    meta: {
      utlTipoFornecimentoId: 1,
      ensaioFresco: true,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Inclusão de Tipo de Ensaio Fresco',
    path: 'tipo-ensaio-fresco/incluir',
    name: 'tipoensaiofrescoinsert',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaiofresco',
      utlTipoFornecimentoId: 1,
      ensaioFresco: true,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Tipo de Ensaio Fresco',
    path: 'tipo-ensaio-fresco/editar/:id',
    name: 'tipoensaiofrescoupdate',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaiofresco',
      utlTipoFornecimentoId: 1,
      ensaioFresco: true,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Tipo de Ensaio Endurecido',
    path: 'tipo-ensaio-endurecido',
    name: 'tipoensaioendurecido',
    redirect: { name: 'tipoensaioconcreto' },
    goesToMenu: false,
    meta: {
      utlTipoFornecimentoId: 1,
      ensaioFresco: false,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Inclusão de Tipo de Ensaio Endurecido',
    path: 'tipo-ensaio-endurecido/incluir',
    name: 'tipoensaioendurecidoinsert',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaioendurecido',
      utlTipoFornecimentoId: 1,
      ensaioFresco: false,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Tipo de Ensaio Endurecido',
    path: 'tipo-ensaio-endurecido/editar/:id',
    name: 'tipoensaioendurecidoupdate',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaioendurecido',
      utlTipoFornecimentoId: 1,
      ensaioFresco: false,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Unidade de Concreto',
    path: 'unidade',
    name: 'unidadeconcreto',
    component: () => import('@/views/gestao/unidade/Index.vue'),
    meta: {
      tipoFornecimento: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Unidade de Concreto',
    path: 'unidade/incluir',
    name: 'inclusaounidadeconcreto',
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadeconcreto',
      tipoFornecimento: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroObra]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Unidade Concreto',
    path: 'unidade/editar/:id',
    name: 'unidadeconcretoupdate',
    meta: {
      parentRouteName: 'unidadeconcreto',
      tipoFornecimento: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue')
  },
  {
    description: 'Unidade Tipo Concreto',
    path: 'unidade-tipo',
    name: 'unidadetipoconcreto',
    component: () => import('@/views/gestao/unidade-tipo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroObra],
      ambienteRouteName: 'ambienteconcreto',
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão Unidade Tipo Concreto',
    path: 'unidade-tipo/incluir',
    name: 'unidadetipoconcretoinsert',
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadetipoconcreto',
      tipoFornecimento: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Unidade Tipo Concreto',
    path: 'unidade-tipo/editar/:id',
    name: 'unidadetipoconcretoupdate',
    meta: {
      parentRouteName: 'unidadetipoconcreto',
      tipoFornecimento: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue')
  },
  {
    description: 'Local de Aplicação',
    path: 'ambiente/:gesUnidadeTipoId',
    name: 'ambienteconcreto',
    component: () => import('@/views/gestao/ambiente/Index.vue'),
    goesToMenu: false,
    meta: {
      tipoFornecimento: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastrosBase],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Local de Aplicação',
    path: 'ambiente/incluir/:gesUnidadeTipoId',
    name: 'ambienteconcretoinsert',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambienteconcreto',
      tipoFornecimento: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Edição de Local de Aplicação',
    path: 'ambiente/editar/:gesUnidadeTipoId/:id',
    name: 'ambienteconcretoupdate',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambienteconcreto',
      tipoFornecimento: 'concreto',
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  }
];
